// // 是否是本地开发环境
export const isDev = location.href.indexOf('http://localhost') === 0 || location.href.indexOf('http://127.0.0.1') === 0;
// 是否是测试环境
export const isTesting = location.href.indexOf('freedom.h5.kf315.net') >= 0;
// 是否是生产环境
export const isProduction = !(isDev || isTesting);
// 本地开发设置
// console.log(location.href)
// console.log(isTesting)
const devConfig = {
  //
  // domain: 'http://localhost:8085/',
  // token: 'a55c08fa067b4727a79c4297434cc8f7',
  // // token: '22f5c7280a4c441aa2c4a895c0751f4e',
  // fileDomain: 'http://filetest.cjm.so/'
  domain: 'http://freedom.cjmjgw.com/datascreen/runda/',
  token: '55ffd124436e4119a95618a20fd9c5a3',
  fileDomain: 'http://file.cjm.so/'
};
// 测试环境设置
const testConfig = {
  //
  domain: 'http://freedom.h5.kf315.net/datascreen/runda/',
  // token: '9c83a7fcd12f440b925a5d5a7dd0d832',
  token: 'a55c08fa067b4727a79c4297434cc8f7',
  fileDomain: 'http://filetest.cjm.so/'
};


// 生产环境设置
// const productionConfig = {
//   domain: 'http://freedom.cjmjgw.com/datascreen/runda/',
//   token: '22f5c7280a4c441aa2c4a895c0751f4e',
//   fileDomain: 'http://file.cjm.so/'
// };

// 生产环境设置
const productionConfig = {
  domain: 'http://freedom.cjmjgw.com/datascreen/runda-yanshi/',
  token: '55ffd124436e4119a95618a20fd9c5a3',
  fileDomain: 'http://file.cjm.so/'
};
//
let config = {};
if (isDev) {
  config = devConfig;
} else if (isTesting) {
  config = testConfig;
} else {
  config = productionConfig;
}
export default config;



// WEBPACK FOOTER //
// ./static/config/config.js